module.exports = __webpack_public_path__ + "static/img/pup-top.3c4f9e9.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/layer2/pup-top.png
// module id = XtVg
// module chunks = 1